import { z } from 'zod';
import { useFormContext } from 'react-hook-form';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  Input,
} from '@sandtech-hub-monorepo/ui-kit';
import {
  ProofOfCompletionExamLocation,
  ProofOfCompletionType,
  ExamStatementType,
} from '@sandtech-hub-monorepo/ehub-client';

export const proofOfCompletionGenericFormSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  emailUsedInExam: z.string().email(),
  examLocation: z
    .custom<ProofOfCompletionExamLocation>()
    .refine((val) => val !== undefined),
  examStatement: z.nativeEnum(ExamStatementType),
});

export const ProofOfCompletionGenericFormFields = ({
  proofOfCompletionType,
}: {
  proofOfCompletionType: ProofOfCompletionType;
}) => {
  const { control } = useFormContext();

  return (
    <>
      <FormField
        control={control}
        name="firstName"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="firstName" className="text-sm">
              First name *
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="lastName"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="lastName" className="text-sm">
              Last name *
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="emailUsedInExam"
        render={({ field }) => (
          <FormItem className="mt-4">
            <FormLabel htmlFor="emailUsedInExam" className="text-sm">
              Email Address used in exam*
            </FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormDescription className="text-xs">
              Ensure you input the correct program email
            </FormDescription>
          </FormItem>
        )}
      />
    </>
  );
};
